<template>
  <div>
    <div class="form-input">
      <el-table
        class="table detailRelatedDocs"
        :data="locations"
        v-if="locations && locations.length"
      >
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-row :gutter="24">
              <el-col :span="12">
                <hc-maybay-user-route-extend-info-item
                  fieldTitle="Số lượng phòng đơn"
                  :value="
                    `${getCount(
                      props.row,
                      HC_CASE_HOTEL_PRICE.ROOM_TYPE.PHONG_DON
                    )}`
                  "
                ></hc-maybay-user-route-extend-info-item>
              </el-col>

              <el-col :span="12">
                <hc-maybay-user-route-extend-info-item
                  fieldTitle="Số lượng phòng đôi"
                  :value="
                    `${getCount(
                      props.row,
                      HC_CASE_HOTEL_PRICE.ROOM_TYPE.PHONG_DOI
                    )}`
                  "
                ></hc-maybay-user-route-extend-info-item>
              </el-col>
            </el-row>
          </template>
        </el-table-column>

        <el-table-column width="40" type="index">
          <template #header
            >#
          </template>
        </el-table-column>

        <el-table-column
          label="Điểm đi"
          show-overflow-tooltip
          property="airportFrom"
        >
          <template slot-scope="scope">
            <div>
              <i class="fas fa-map-marker-alt color__blue"></i>
              <break-word-span
                :text="getPlaceLabel(scope.row)"
                :maxLength="100"
              ></break-word-span>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          label="Thời gian checkin / checkout"
          show-overflow-tooltip
          property="flightTimeEstimate"
          align="left"
          width="200px"
        >
          <template slot-scope="scope">
            <div>
              <i class="fas fa-arrow-right color__blue"></i>
              <span class="font-size__small">In: </span>
              <break-word-span
                :text="getDatetimeLabel(scope.row.checkIn)"
                :maxLength="25"
              ></break-word-span>
              <br />
              <i class="fas fa-arrow-left color__red"></i>
              <span class="font-size__small">Out: </span>
              <break-word-span
                :text="getDatetimeLabel(scope.row.checkOut)"
                :maxLength="25"
              ></break-word-span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import constants from "../../../constants";
import hcCaseHotelLocationViewService from "../../../services/khachsan/hcCaseHotelLocationViewService";
import hcCaseHotelPriceService from "../../../services/khachsan/hcCaseHotelPriceService";
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import uploadFileMixin from "../../doc-in/uploadFileMixin";
import BreakWordSpan from "../ketluan/break-word-span";
import h from "../../../services/h";
import dateFormatter from "../../../filters/dateFormatter";
import HcMaybayUserRouteExtendInfoItem from "../vemaybay/hc-maybay-user-route-extend-info-item";

export default {
  name: "hc-ks-places-readonly",
  mixins: [handleRequestErrorMixin, uploadFileMixin],
  components: { HcMaybayUserRouteExtendInfoItem, BreakWordSpan },
  props: ["hcCaseMasterId"],

  data() {
    return {
      locations: [],
      hcCaseHotelPrices: [],
      HC_CASE_HOTEL_PRICE: constants.HC_CASE_HOTEL_PRICE
    };
  },

  watch: {
    hcCaseMasterId() {
      this.initComponent();
    }
  },

  created() {
    this.initComponent();
  },

  methods: {
    async initComponent() {
      await this.loadHcCaseHotelLocationView();
      await this.loadHcCaseHotelPrices();
    },

    getDatetimeLabel(time) {
      return time ? dateFormatter(time) : "-";
    },

    loadHcCaseHotelLocationView() {
      return hcCaseHotelLocationViewService
        .findByHcCaseMaster(this.hcCaseMasterId)
        .then(response => (this.locations = response.data));
    },

    loadHcCaseHotelPrices() {
      return hcCaseHotelPriceService
        .findByHcCaseMaster(this.hcCaseMasterId)
        .then(response => (this.hcCaseHotelPrices = response.data));
    },

    getPrice(location, roomType) {
      return h.find(
        this.hcCaseHotelPrices,
        item => item.locationId === location.id && item.roomType === roomType
      );
    },

    getCount(location, roomType) {
      let price = this.getPrice(location, roomType);
      return (price ? price.countRoom : null) || 0;
    },

    getPlaceLabel(location) {
      let temp_ = [];
      if (location.locationName) temp_.push(`(${location.locationName})`);
      if (location.hotelName) temp_.push(location.hotelName);
      return temp_.join(" ");
    }
  }
};
</script>

<style scoped>
.download-icon:hover {
  color: var(--color-blue) !important;
}
</style>



// WEBPACK FOOTER //
// src/views/adminstration/khachsan/hc-ks-places-readonly.vue